module.exports = __webpack_public_path__ + "static/media/search-medications.944bc2e2.png";